(() => {
  if (window.stProductReviewLinksReady) return;
  window.stProductReviewLinksReady = true;
  document.addEventListener('click', (event) => {
    const widget = event.target.closest('[data-st-review-url]');
    if (!widget) return;
    const url = new URL(widget.dataset.stReviewUrl, window.location.origin);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(url.href);
  }, true);
})();
